import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Scroll from 'react-scroll';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import ProjectController from '../../controller/ProjectController';

import ProjectAddEditInfo from './ProjectAddEditInfo';
import ProjectAddEditCustom from './ProjectAddEditCustom';
import ProjectContactDetails from './ProjectContactDetails';


import ProjectAPI from '../../api/ProjectAPI';
import ApiUiController from '../../controller/ApiUiController';
import ValidationController from '../../controller/ValidationController';
import Util from '../../util/Util';

class ProjectUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.projectId);
    
    this.model = reactLocalStorage.getObject(Const.Model).project;
    
    this.project = ProjectController.addModel(this.model.fields);

    Object.keys(this.project).forEach(key => {
      if (this.project[key] === null) {
        this.project[key] = "";
      }
    });
    this.project.id = 0;
    this.state = { inApiCall: this.id !== 0, inValid: {}  };
    
    this.base = this.props.match.path
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
  }

  componentDidMount() {
    if(this.id !== 0) {
      ProjectAPI.get(this.id, this.onReceived, this.failure, this.props.logout);
    }
  }

  failure = res => {
    Scroll.scroller.scrollTo(Object.keys(res)[0], { duration: 1500, smooth: true });
    const message = Util.failure(res);
    this.props.failure({ message });
    this.setState({ ...this.state, inApiCall: false, inValid: { ...res } });
  }

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.project);
    if(inValid === null) {
      this.setState({ ...this.state, inApiCall: true });
      ProjectAPI.saveProject(this.project, this.onUpdateReceived, this.failure, this.props.logout);
      Util.showNotification('Successful', 'Project saved successfully', 'success');
    } else {
      const message = Util.failure(inValid);
      Util.showError(message);
      Scroll.scroller.scrollTo(Object.keys(inValid)[0], { duration: 1500, smooth: true });
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  }
  onReceived = project => {   Object.keys(project).forEach(key => {
      if (project[key] === null) {
        project[key] = "";
      }
    }); this.project = project; this.setState({ inApiCall: false }); }
  onUpdateReceived = res => this.props.navigate(`${this.base}/preview/${res.id}`);

  onValueChange = (field, value) => {
     if (value === null) value = "";
    this.project[field] = value;
    this.setState({ ...this.state, inValid: {} });
  }
  
  render() {
    return (
      <div className="sectionform">
        <div className="container form-cont">
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              
              <ProjectAddEditInfo model={this.model} project={this.project}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />

              <ProjectContactDetails model={this.model} project={this.project}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />

              <ProjectAddEditCustom model={this.model} project={this.project} fieldOption={this.fieldOption}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />
              
              <div className="col-md-12 text-center btnsend">
                <Button className="buttons btn-success" onClick={this.onSave}>
                  { this.id === 0 ? 'Save' : 'Update' } Project
                </Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default withRouter(ProjectUpdate);